export const antennaProducts = [
  {
    title: {
      sv: "40 MHz Antennkit 1/4-våg",
      en: "40 MHz Antenna kit 1/4-wave",
    },
    description: {
      sv: "5 m kabel • BNC-kontakt • Artikelnummer: AK40-1",
      en: "5 m cable • BNC connector • Article number: AK40-1",
    },
    image: "/images/products/Antenner/AK40.png",
    gallery: ["/images/products/Antenner/AK40.png"],
    slug: "ak40-1",
    category: "antenn",
    pdfs: [
      {
        label: { sv: "Produktblad – AK40-1", en: "Product sheet – AK40-1" },
        url: "/pdfs/smd/Antenner/AK40-1 Produktblad.pdf",
      },
    ],
    features: [
      {
        title: {
          sv: "Komplett antennkit för snabb installation",
          en: "Complete antenna kit for quick installation",
        },
        description: {
          sv: "Levereras komplett med antenn, antennfot och kabel för enkel montering.",
          en: "Delivered complete with antenna, antenna base and cable for easy mounting.",
        },
      },
      {
        title: {
          sv: "Optimerad för 40 MHz-system",
          en: "Optimized for 40 MHz systems",
        },
        description: {
          sv: "Utvecklad för stabil och tillförlitlig radiokommunikation i 40 MHz-applikationer.",
          en: "Developed for stable and reliable radio communication in 40 MHz applications.",
        },
      },
      {
        title: { sv: "Flexibel montering", en: "Flexible mounting" },
        description: {
          sv: "Finns med flera kabellängder för att passa både fordon, maskiner och fasta installationer.",
          en: "Available with multiple cable lengths to suit both vehicles, machines and fixed installations.",
        },
      },
      {
        title: { sv: "Robust konstruktion", en: "Robust construction" },
        description: {
          sv: "Tillverkad för professionell användning där driftsäkerhet och lång livslängd är viktiga.",
          en: "Manufactured for professional use where operational reliability and long service life are important.",
        },
      },
    ],
  },
  {
    title: {
      sv: "DB Antennkit Dual Band",
      en: "DB Antenna kit Dual Band",
    },
    description: {
      sv: "433 / 868 / 915 MHz • RP-SMA • 2 eller 5 m kabel • Artikelnummer: AKDB-SMA-2M / AKDB-SMA-5M",
      en: "433 / 868 / 915 MHz • RP-SMA • 2 or 5 m cable • Article number: AKDB-SMA-2M / AKDB-SMA-5M",
    },
    image: "/images/products/Antenner/AKDB.png",
    gallery: ["/images/products/Antenner/AKDB.png"],
    slug: "akdb-dual-band",
    category: "antenn",
    pdfs: [
      {
        label: { sv: "Produktblad – AKDB-SMA", en: "Product sheet – AKDB-SMA" },
        url: "/pdfs/smd/Antenner/AKDB-SMA Produktblad.pdf",
      },
    ],
    features: [
      {
        title: {
          sv: "Komplett antennkit för enkel installation",
          en: "Complete antenna kit for easy installation",
        },
        description: {
          sv: "Levereras komplett med antenn, fäste, kabel och RP-SMA-kontakt för snabb och smidig montering.",
          en: "Delivered complete with antenna, bracket, cable and RP-SMA connector for quick and easy mounting.",
        },
      },
      {
        title: {
          sv: "Dual Band för flera frekvensområden",
          en: "Dual Band for multiple frequency ranges",
        },
        description: {
          sv: "Utvecklad för 433 MHz, 868 MHz och 915 MHz, vilket gör antennen till en flexibel lösning för flera radiosystem.",
          en: "Developed for 433 MHz, 868 MHz and 915 MHz, making the antenna a flexible solution for multiple radio systems.",
        },
      },
      {
        title: { sv: "Flexibel installation", en: "Flexible installation" },
        description: {
          sv: "Finns med 2 eller 5 meters kabel och kan även kundanpassas med andra kabellängder eller BNC-kontakt vid behov.",
          en: "Available with 2 or 5 metre cable and can also be customized with other cable lengths or BNC connector if needed.",
        },
      },
      {
        title: {
          sv: "Robust konstruktion för professionell användning",
          en: "Robust construction for professional use",
        },
        description: {
          sv: "Byggd för industriella miljöer där stabil radiokommunikation och lång livslängd är avgörande.",
          en: "Built for industrial environments where stable radio communication and long service life are essential.",
        },
      },
    ],
  },
  {
    title: {
      sv: "433 MHz Stålantenn 1/2-våg",
      en: "433 MHz Steel antenna 1/2-wave",
    },
    description: {
      sv: "1–5 m kabel • BNC eller RP-SMA • Artikelnummer: AK433-1 / AK433-4",
      en: "1–5 m cable • BNC or RP-SMA • Article number: AK433-1 / AK433-4",
    },
    image: "/images/products/Antenner/AK433-1.png",
    gallery: ["/images/products/Antenner/AK433-1.png"],
    slug: "ak433-stalantenn",
    category: "antenn",
    pdfs: [
      {
        label: { sv: "Produktblad – AK433-4", en: "Product sheet – AK433-4" },
        url: "/pdfs/smd/Antenner/AK433-4 Produktblad.pdf",
      },
    ],
    features: [
      {
        title: {
          sv: "Komplett antennkit för enkel installation",
          en: "Complete antenna kit for easy installation",
        },
        description: {
          sv: "Levereras komplett med antenn, antennfot och kabel för snabb och smidig montering.",
          en: "Delivered complete with antenna, antenna base and cable for quick and easy mounting.",
        },
      },
      {
        title: { sv: "Optimerad för 433 MHz", en: "Optimized for 433 MHz" },
        description: {
          sv: "Utvecklad för stabil radiokommunikation i 433 MHz-system med hög driftsäkerhet och god signalprestanda.",
          en: "Developed for stable radio communication in 433 MHz systems with high operational reliability and good signal performance.",
        },
      },
      {
        title: { sv: "Flexibel anslutning", en: "Flexible connection" },
        description: {
          sv: "Finns med både BNC- och RP-SMA-kontakt för att passa olika mottagare och installationer.",
          en: "Available with both BNC and RP-SMA connector to suit different receivers and installations.",
        },
      },
      {
        title: {
          sv: "Robust konstruktion för professionell användning",
          en: "Robust construction for professional use",
        },
        description: {
          sv: "Slitstark stålantenn utvecklad för industri, entreprenadmaskiner och andra krävande miljöer.",
          en: "Durable steel antenna developed for industry, construction machines and other demanding environments.",
        },
      },
    ],
  },
  {
    title: {
      sv: "433 MHz Flexantenn 1/4-våg",
      en: "433 MHz Flex antenna 1/4-wave",
    },
    description: {
      sv: "1–5 m kabel • BNC eller RP-SMA • Artikelnummer: AK433-2 / AK433-5",
      en: "1–5 m cable • BNC or RP-SMA • Article number: AK433-2 / AK433-5",
    },
    image: "/images/products/Antenner/AK433-2.png",
    gallery: ["/images/products/Antenner/AK433-2.png"],
    slug: "ak433-flexantenn",
    category: "antenn",
    pdfs: [
      {
        label: { sv: "Produktblad – AK433-5", en: "Product sheet – AK433-5" },
        url: "/pdfs/smd/Antenner/AK433-5 Produktblad.pdf",
      },
    ],
    features: [
      {
        title: {
          sv: "Komplett antennkit för snabb montering",
          en: "Complete antenna kit for quick mounting",
        },
        description: {
          sv: "Levereras komplett med flexibel antenn, antennfot och kabel för enkel installation.",
          en: "Delivered complete with flexible antenna, antenna base and cable for easy installation.",
        },
      },
      {
        title: { sv: "Optimerad för 433 MHz", en: "Optimized for 433 MHz" },
        description: {
          sv: "Anpassad för stabil och driftsäker radiokommunikation i 433 MHz-system.",
          en: "Adapted for stable and reliable radio communication in 433 MHz systems.",
        },
      },
      {
        title: { sv: "Flexibel anslutning", en: "Flexible connection" },
        description: {
          sv: "Finns med både BNC- och RP-SMA-kontakt för kompatibilitet med flera olika radiomottagare.",
          en: "Available with both BNC and RP-SMA connector for compatibility with multiple radio receivers.",
        },
      },
      {
        title: { sv: "Kompakt och tålig konstruktion", en: "Compact and durable construction" },
        description: {
          sv: "Den flexibla antennen är väl lämpad för installationer där utrymmet är begränsat eller där antennen riskerar att utsättas för stötar och vibrationer.",
          en: "The flexible antenna is well suited for installations where space is limited or where the antenna risks being exposed to shocks and vibrations.",
        },
      },
    ],
  },
  {
    title: {
      sv: "433 MHz Dipolantenn 1/2-våg",
      en: "433 MHz Dipole antenna 1/2-wave",
    },
    description: {
      sv: "1, 5 eller 10 m kabel • RP-SMA eller BNC • Artikelnummer: AK433-3 / AK433-6",
      en: "1, 5 or 10 m cable • RP-SMA or BNC • Article number: AK433-3 / AK433-6",
    },
    image: "/images/products/Antenner/AK433-3.png",
    gallery: ["/images/products/Antenner/AK433-3.png"],
    slug: "ak433-dipolantenn",
    category: "antenn",
    pdfs: [
      {
        label: { sv: "Produktblad – AK433-6 Dipol", en: "Product sheet – AK433-6 Dipole" },
        url: "/pdfs/smd/Antenner/AK433-6 Produktblad Dipol.pdf",
      },
    ],
    features: [
      {
        title: {
          sv: "Robust dipolantenn för utomhusbruk",
          en: "Robust dipole antenna for outdoor use",
        },
        description: {
          sv: "Väderbeständig dipolantenn med slitstark kapsling och integrerat väggfäste för säker montering.",
          en: "Weather-resistant dipole antenna with durable housing and integrated wall bracket for secure mounting.",
        },
      },
      {
        title: { sv: "Optimerad för 433 MHz", en: "Optimized for 433 MHz" },
        description: {
          sv: "Utvecklad för stabil och lång räckvidd inom 433 MHz-system med hög driftsäkerhet.",
          en: "Developed for stable and long range within 433 MHz systems with high operational reliability.",
        },
      },
      {
        title: { sv: "Flera kabelalternativ", en: "Multiple cable options" },
        description: {
          sv: "Finns med 1, 5 eller 10 meters kabel och levereras som standard med RP-SMA-kontakt. BNC-kontakt kan fås vid behov.",
          en: "Available with 1, 5 or 10 metre cable and delivered as standard with RP-SMA connector. BNC connector can be provided if needed.",
        },
      },
      {
        title: {
          sv: "Komplett lösning för fast installation",
          en: "Complete solution for fixed installation",
        },
        description: {
          sv: "Perfekt för fasta installationer där en extern antenn ger bättre täckning och mer tillförlitlig radiokommunikation.",
          en: "Perfect for fixed installations where an external antenna provides better coverage and more reliable radio communication.",
        },
      },
    ],
  },
];
